import React from 'react'
import Layout from '../components/layout/base'


class NotFoundPage extends React.Component {
  render() {
    return (
      <Layout location={this.props.location}>
        <h1>Page Not Found</h1>
        <p>Looks like this link doesn't work.</p>
      </Layout>
    )
  }
}

export default NotFoundPage
